import http from "../../http";

export default {
  tree: (params) => {
    return http.get("opservice/tree?rang=tenant", params);
  },
  save: (params) => {
    return http.post("opservice/save", params);
  },
  delete: (params) => {
    return http.post("opservice/delete", params);
  },
};
